_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[21],{

/***/ "GH8k":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artykuly/[slug]",
      function () {
        return __webpack_require__("zBjJ");
      }
    ]);
  

/***/ }),

/***/ "TAcS":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"articleSection_section__2jP8A","heading":"articleSection_heading__1utQ3","buttons":"articleSection_buttons__27iIU","article":"articleSection_article__2NPHO","publishDate":"articleSection_publishDate__ItdSn","title":"articleSection_title__3wPKz","linkWrapper":"articleSection_linkWrapper__2s6tb","linkHeader":"articleSection_linkHeader__3rbyl","favicon":"articleSection_favicon__1ADXB"};

/***/ }),

/***/ "zBjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSG", function() { return /* binding */ __N_SSG; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/babel-plugin-superjson-next/tools.js
var tools = __webpack_require__("eLM2");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// CONCATENATED MODULE: ./utils/creator-utils.ts
// Detect YouTube videos by the article URL
var ytRegex = /youtu(\.be|be\.com)\//; // Detect podcasts by the anchor.fm in article URL (most popular hosting) or podcast name (common words like talk or podcast)

var podcastRegex = /(anchor\.fm\/|talk|podcast)/i;
var detectContentGenre = function detectContentGenre(article) {
  if (ytRegex.test(article.href)) {
    return 'youtube';
  } else if (podcastRegex.test(article.href) || podcastRegex.test(article.blog.name)) {
    return 'podcast';
  } else {
    return 'blog';
  }
};
// EXTERNAL MODULE: ./utils/date-utils.ts
var date_utils = __webpack_require__("R2ni");

// EXTERNAL MODULE: ./utils/link-utils.ts
var link_utils = __webpack_require__("tsCB");

// EXTERNAL MODULE: ./components/Button/Button.tsx + 2 modules
var Button = __webpack_require__("89Ff");

// EXTERNAL MODULE: ./components/ArticleSection/articleSection.module.scss
var articleSection_module = __webpack_require__("TAcS");
var articleSection_module_default = /*#__PURE__*/__webpack_require__.n(articleSection_module);

// CONCATENATED MODULE: ./components/ArticleSection/ArticleSection.tsx









var linkLabels = {
  blog: 'Przejdź do artykułu',
  podcast: 'Przejdź do podcastu',
  youtube: 'Przejdź do filmu'
};
var ArticleSection = /*#__PURE__*/Object(react["memo"])(function (_ref) {
  var article = _ref.article;
  var readableDate = Object(date_utils["a" /* formatDate */])(article.publishedAt);
  var articleLinkLabel = linkLabels[detectContentGenre(article)];
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("section", {
    className: articleSection_module_default.a.section,
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
      className: articleSection_module_default.a.heading,
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: Object(link_utils["a" /* addTrackingToLink */])(article.blog.href, {
          utm_medium: 'article_page'
        }),
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("img", {
            loading: "lazy",
            src: article.blog.favicon || undefined,
            alt: "",
            className: articleSection_module_default.a.favicon,
            height: 16,
            width: 16
          }), article.blog.name]
        })
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
      className: articleSection_module_default.a.buttons,
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* Button */], {
          icon: "icon-arrow-left2",
          as: "a",
          children: "Strona G\u0142\xF3wna"
        })
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("article", {
      className: articleSection_module_default.a.article,
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h3", {
        className: articleSection_module_default.a.title,
        children: article.title
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("time", {
        className: articleSection_module_default.a.publishDate,
        children: readableDate
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        dangerouslySetInnerHTML: {
          __html: article.sanitizedDescription
        }
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("section", {
        className: articleSection_module_default.a.linkWrapper,
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          className: articleSection_module_default.a.linkHeader,
          children: "Chcesz wi\u0119cej? Sprawd\u017A w oryginale!"
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
          href: Object(link_utils["a" /* addTrackingToLink */])(article.href, {
            utm_medium: 'article_page'
          }),
          passHref: true,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* Button */], {
            icon: "icon-new-tab",
            as: "a",
            target: "_blank",
            rel: "noopener noreferrer",
            children: articleLinkLabel
          })
        })]
      })]
    })]
  });
});
ArticleSection.displayName = 'ArticleSection';
// EXTERNAL MODULE: ./components/Layout.tsx + 4 modules
var Layout = __webpack_require__("apO0");

// CONCATENATED MODULE: ./pages/artykuly/[slug].tsx




var __N_SSG = true;

function ArticlePage(_ref) {
  var article = _ref.article;
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(Layout["a" /* Layout */], {
    title: article.title,
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(ArticleSection, {
      article: article
    })
  });
}

/* harmony default export */ var _slug_ = __webpack_exports__["default"] = (Object(tools["withSuperJSONPage"])(ArticlePage));

/***/ })

},[["GH8k",0,1,2,4,3,5,6,7]]]);